export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_06.3ec5514a.jpg";